if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // const config = fetchConfig('javascript');
        // config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // delete config.headers['Content-Type'];

        // const formData = new FormData(this.form);
        // if (this.cart) {
        //   formData.append(
        //     'sections',
        //     this.cart.getSectionsToRender().map((section) => section.id)
        //   );
        //   formData.append('sections_url', window.location.pathname);
        //   this.cart.setActiveElement(document.activeElement);
        // }
        // config.body = formData;


        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const selectedAddons = document.querySelectorAll('.product-addon-checkbox:checked');

        if (selectedAddons.length > 0) {
          config.headers['Content-Type'] = 'application/json';
          const mainVariantId = formData.get('id');
          const quantity = parseInt(formData.get('quantity') || '1', 10);
          const productTitle =
            document.querySelector('.product__title h1')?.textContent?.trim() ||
            document.querySelector('.product__title')?.textContent?.trim() ||
            'Scooter';

          const items = [
            {
              id: parseInt(mainVariantId, 10),
              quantity: quantity,
            },
          ];

          selectedAddons.forEach((checkbox) => {
            const variantId = checkbox.dataset.variantId || checkbox.value;
            if (variantId) {
              items.push({
                id: parseInt(variantId, 10),
                quantity: quantity,
                properties: {
                  'Add-on For': productTitle,
                },
              });
            }
          });

          const jsonPayload = { items: items };

          if (this.cart) {
            jsonPayload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            jsonPayload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = JSON.stringify(jsonPayload);
        } else {
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }




        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

    // Dynamic Checkout / Buy It Now interceptor for product add-ons
  document.addEventListener(
    'click',
    function (evt) {
      const buyNowBtn = evt.target.closest('.shopify-payment-button__button, [data-testid="Checkout-button"]');
      if (!buyNowBtn) return;

      const form = buyNowBtn.closest('form') || document.querySelector('product-form form');
      const selectedAddons = document.querySelectorAll('.product-addon-checkbox:checked');
      if (selectedAddons.length === 0) return;

      const mainVariantInput = form ? form.querySelector('[name="id"]') : null;
      const mainVariantId = mainVariantInput ? mainVariantInput.value : null;
      const qtyInput = form ? form.querySelector('[name="quantity"]') : null;
      const qty = qtyInput ? qtyInput.value : '1';

      if (mainVariantId) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        let permalink = `/cart/${mainVariantId}:${qty}`;
        selectedAddons.forEach((checkbox) => {
          const addonId = checkbox.dataset.variantId || checkbox.value;
          if (addonId) {
            permalink += `,${addonId}:${qty}`;
          }
        });

        window.location.href = permalink;
      }
    },
    true
  );